import { LinkAction } from '@leverege/molten/routes';
import { Config } from '@leverege/plugin';
import { Routes, Types } from "../../constants/index.js";
export default LinkAction.create({
  id: 'leverege.fotaApi.link.firmwareRelease.info',
  matches: {
    use: 'navBar',
    client: 'ItemScreen',
    objectType: Types.firmwareRelease,
    path: 'leverege.fotaApi.firmwareRelease'
  },
  path: Routes.rootFirmwareReleaseItemInfo,
  name: 'Overview',
  layout: {
    sort() {
      return Config.get('LeveregeFota', 'rootFirmwareReleaseItemInfoLinkSort', 'aaa');
    }
  },
  icon: () => Config.get('LeveregeFota', 'firmwareReleaseItemInfoNavIcon')
});